import { useEffect } from "react";
import { ParamsWatcher } from "../helpers/params";

export type ParamWatchPath<K extends string> = [
    key: K,
    path: string,
    updateSec?: number,
    priority?: "low" | "normal" | "high",
];

export default function useRealtimeParamsData<K extends string>(
    params: ParamsWatcher,
    settings: ParamWatchPath<K>[],
): void {
    useEffect(() => {
        for (const [key, path, updateSec = undefined, priority] of settings) {
            try {
                params.realtime(key, path, updateSec && updateSec * 1000, priority);
            } catch (e) {
                // eslint-disable-next-line no-console
                console.error(
                    `Can't set parameter "${key}"=>"${path}" watch: ${
                        (e as Error).message
                    }, storeKey: ${params.getStoreKey()}`,
                );
            }
        }

        return () => {
            params.removeWatchedItems(settings.map((item) => item[0]));
        };
    }, [settings.map(([key, path, updateSec]) => `${key}:${path}:${updateSec}`).join(",")]);
    // return useSyncExternalStore(store.subscribe, store.getSnapshot) as {
    //     [key in K]: string | undefined;
    // };
}
